import Vue from 'vue'

let bus = new Vue();

export const eventBus = bus;
export default bus;



// WEBPACK FOOTER //
// ./src/eventBus.js